import React from "react";
import DOMPurify from "dompurify";
import "./ProjectReport.css";

const isStorageVideo = (url) => url && (url.includes('firebasestorage') || /\.(mp4|webm|mov)(\?|$)/i.test(url));

const ProjectReport = ({ reportData }) => {
  if (!reportData || !reportData.title) {
    return <div>Error: Report data is incomplete.</div>;
  }

  const { title, bodyHtml, images, videoUrl } = reportData;

  return (
    <div className="project-report-card">
      <h3 className="project-report-title">{title}</h3>
      {bodyHtml && (
        <div
          className="project-report-description"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bodyHtml) }}
        />
      )}
      {Array.isArray(images) && images.length > 0 && (
        <div className="project-report-gallery">
          {images.map((image, i) => (
            <img key={i} src={image.url} alt={image.alt || title} className="project-report-gallery-image" />
          ))}
        </div>
      )}
      {videoUrl && (
        isStorageVideo(videoUrl)
          ? <video className="project-report-video" src={videoUrl} controls />
          : (
            <p>
              <a href={videoUrl} target="_blank" rel="noreferrer" className="project-report-video-link">
                Projektvideo ansehen
              </a>
            </p>
          )
      )}
    </div>
  );
};

export default ProjectReport;
